<div class="">
  <div class="flex items-center justify-center mx-auto">
    <svg-icon src="assets/svgs/cancel-icon.svg" [svgStyle]="{ 'width.px': 60, 'height.px': 60 }" [ngClass]="{
        '[&_svg]:!w-10  [&_svg]:!h-10 md:[&_svg]:!w-[77px] md:[&_svg]:!h-[77px]': true
      }"></svg-icon>
  </div>

  <div [ngClass]="{ 'flex flex-col gap-6 pt-6': true }">
    <div>
      <p class="px-6 text-base font-semibold text-center md:text-lg lg:text-2xl text-tw-text-color">
        Email Verification Not Successful
      </p>
      <p [ngClass]="{ 'text-center': true }">Please try again</p>
    </div>

    <div class="flex justify-center">
      <button nz-button class="" nzSize="large" nzType="primary" type="button" (click)="resendEmail()"
        [disabled]="resendEmailResponse.isPending()">Resend Email</button>
    </div>
  </div>

  <!-- <div class="flex flex-col items-center gap-4 pt-10 text-center">
        <h5 class="text-black text-[32px] leading-[38px] font-semibold">
            {{verifyEmailResponse.isPending()?'Verifying email':'Email Verified'}}</h5>
        <div class="text-center text-[#5D5E5E] text-lg font-semibold">
            <p class="text-[#5D5E5E]">{{verifyEmailResponse.isPending()?'Verifying your account. Please\
                wait...':'You have successfully verified your account.'}}</p>
        </div>
        <div class="text-center text-[#5D5E5E] text-lg pt-4">
            <button
                [ngClass]="{'p-[10px] text-base bg-tw-primary text-white w-[176px] rounded-lg font-semibold': true,'disabled:opacity-50':!verifyEmailResponse.data()}"
                (click)="switchToLogin()" [disabled]="!verifyEmailResponse.data()">Login</button>
        </div>
    </div> -->
</div>